const OVERLAP_SELECTOR = '.section-set-height';
const HERO_CLASS = 'hero';
const HERO_GAP = 50;

/**
 * Keeps a `.section-set-height` block centered on the bottom edge of the
 * Hero directly before it: half its own rendered height sits inside the
 * Hero (via the Hero's padding-bottom), half sits below it (via a matching
 * negative margin-top). Both values are re-derived from a ResizeObserver
 * so they stay correct if the block's content changes height after load
 * (images finishing, font swap, window resize, etc).
 */
class OverlapSection {
    constructor(section) {
        this.section = section;
        this.hero = section.previousElementSibling;

        if (null === this.hero || false === this.hero.classList.contains(HERO_CLASS)) {
            return;
        }

        this.onResize = this.onResize.bind(this);

        this.observer = new ResizeObserver(this.onResize);
        this.observer.observe(this.section);
    }

    onResize() {
        const halfHeight = Math.round(this.section.offsetHeight / 2);

        this.hero.style.paddingBottom = `${halfHeight + HERO_GAP}px`;
        this.section.style.marginTop = `-${halfHeight}px`;
    }
}

document.addEventListener('DOMContentLoaded', () => {
    // Iterate so more than one block on a page each get their own instance.
    document.querySelectorAll(OVERLAP_SELECTOR).forEach((section) => {
        new OverlapSection(section);
    });
});
